var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "95%",
      "scrollable": true,
      "name": "client-visit-change",
      "classes": "modal_default",
      "clickToClose": true
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "visit-reschedule-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Přeplánovat návštěvu\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('form', [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.planned_for),
      expression: "visit.planned_for"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "visit-reschedule-doctor"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadCalendar()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.branch_id),
      expression: "visit.branch_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "branchHelp",
      "id": "branch",
      "placeholder": "vybrat pobočku",
      "data-testid": "visit-reschedule-branch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.branch_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit pobočku")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.purpose_id),
      expression: "visit.purpose_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "operation",
      "data-testid": "visit-reschedule-purpose"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.purpose_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.visitPurposeChanged($event)
      }]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      attrs: {
        "data-duration": visit_purpose.duration
      },
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-inline mt-2"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.duration),
      expression: "visit.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration",
      "data-testid": "visit-reschedule-duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSelectedWindows()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("0 minut")]), _vm._v(" "), _vm._l((24), function(duration) {
    return (duration % 2 === 0) ? _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")]) : _vm._e()
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("\n                            akutní "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.acute),
      expression: "visit.acute"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "data-testid": "visit-reschedule-acute"
    },
    domProps: {
      "checked": Array.isArray(_vm.visit.acute) ? _vm._i(_vm.visit.acute, null) > -1 : (_vm.visit.acute)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visit.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visit.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visit.acute = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.visit.notify) ? _c('i', {
    staticClass: "fa fa-bell-o fa-2x text-success",
    attrs: {
      "title": "notifikace jsou zapnuté",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.changeNotification
    }
  }) : _c('i', {
    staticClass: "fa fa-bell-slash fa-2x text-danger",
    attrs: {
      "title": "notifikace jsou VYPNUTY",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.changeNotification
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka:")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.note),
      expression: "visit.note"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "note",
      "rows": "2",
      "data-testid": "visit-reschedule-note"
    },
    domProps: {
      "value": (_vm.visit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit.note = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('table', {
    staticClass: "table table_free_time"
  }, _vm._l((_vm.freeTime), function(ft) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ft.date) + " (" + _vm._s(_vm.$moment(ft.date, 'DD.MM.YYYY').format('dddd')) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$moment(_vm.windowToTime(ft.window)).format('LT')) + " (" + _vm._s(_vm._f("minutesToCsTime")(_vm._f("windowToMinute")(ft.length))) + ")")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-success btn-xs m-1",
      on: {
        "click": function($event) {
          _vm.setCalendarTo(ft.date, ft.window)
        }
      }
    }, [_vm._v("vybrat")])])])
  }))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.actual_select.selected) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.$moment(_vm.actual_select.date).format('dddd')) + " " + _vm._s(_vm.$moment(_vm.actual_select.date).format('LL')) + " v " + _vm._s(_vm.$moment(_vm.actual_select.date).format('LT'))), _c('br')]) : _c('div', [_vm._v("\n            Vyberte den a čas v kalendáři\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "visit-reschedule-previous-week"
    },
    on: {
      "click": function($event) {
        _vm.previousPeriod()
      }
    }
  }, [_vm._v("Předchozí")])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.actualPeriod
    }
  }, [_vm._v("aktuální týden")])]), _vm._v(" "), _c('div', [_c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput"
    },
    on: {
      "input": _vm.manualSelectDate
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "visit-reschedule-next-week"
    },
    on: {
      "click": function($event) {
        _vm.nextPeriod()
      }
    }
  }, [_vm._v("Následující")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div'), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.get_params.from) + " - " + _vm._s(_vm.get_params.to) + "\n            ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "div_table"
  }, [_c('table', {
    staticClass: "table table_calendar"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / _vm.windowsPerHour)), function(times, index) {
    return _c('th', {
      attrs: {
        "colspan": _vm.windowsPerHour
      }
    }, [_vm._v("\n                        " + _vm._s((index + _vm.startHour) < 10 ? '0' + (index + _vm.startHour) : (index + _vm.startHour)) + "\n                    ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / (_vm.windowsPerHour / 2))), function(times, index) {
    return _c('th', {
      staticClass: "halfHour",
      attrs: {
        "colspan": (_vm.windowsPerHour / 2)
      }
    }, [_vm._v("\n                         \n                    ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th')])]), _vm._v(" "), (_vm.visits !== false) ? _c('tbody', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._l((7), function(n) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: '<b>' + _vm.windowsHover(_vm.startWindow + cell - 1) + '</b><br>' + (_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit'].length > 0 ? _vm.windowsHoverVisits(_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit']) : ''),
            placement: 'bottom-center',
            classes: ['info']
          }),
          expression: "{\n                            content: '<b>' + windowsHover(startWindow + cell - 1) + '</b><br>' + (visits[n-1][cell + startWindow - 1]['visit'].length > 0 ? windowsHoverVisits(visits[n-1][cell + startWindow - 1]['visit']) : ''),\n                            placement: 'bottom-center',\n                            classes: ['info']}"
        }],
        class: _vm.getRightClassForTd(_vm.visits[n - 1][cell + _vm.startWindow - 1]) + ' ' + ((cell % _vm.windowsPerHour === 0) ? 'hourly' : '') + ' ' + ((cell % _vm.windowsPerHour === _vm.windowsPerHour / 2) ? 'halfhourly' : ''),
        attrs: {
          "data-window-id": (n - 1) + '_' + (_vm.startWindow + cell - 1),
          "data-testid": 'visit-reschedule-slot-' + (n - 1) + '-' + (_vm.startWindow + cell - 1),
          "data-branch-id": _vm.getBranchIdForTd(_vm.visits[n - 1][cell + _vm.startWindow - 1])
        },
        on: {
          "mouseover": _vm.hoverWindows,
          "mouseleave": _vm.unhoverWindows,
          "click": function($event) {
            _vm.prepareVisit(_vm.startWindow + cell - 1, _vm.$moment(_vm.render_start_date).add(n - 1, 'days'), $event.target)
          }
        }
      }, [_vm._v("\n                           \n                          "), _vm._l((_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit']), function(visit) {
        return [_c('div', {
          staticStyle: {
            "position": "relative"
          }
        }, [_c('div', {
          staticClass: "visit_slot",
          staticStyle: {
            "position": "absolute"
          },
          style: ({
            backgroundColor: '#' + visit.visit_purpose.color,
            top: visit.row_slot_number * 6 + 'px'
          }),
          attrs: {
            "title": _vm.visitSlotHover(visit)
          }
        })])]
      })], 2)
    })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return [(_vm.visits[n - 1][cell + _vm.startWindow - 1]['skipNote'] === 0 || _vm.visits[n - 1][cell + _vm.startWindow - 1]['type'] !== 'work') ? _c('td', {
        staticStyle: {
          "position": "relative"
        },
        attrs: {
          "colspan": _vm.visits[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.visits[n - 1][cell + _vm.startWindow - 1]['note']['windowsCount'] : 1
        }
      }, [_c('div', {
        staticStyle: {
          "position": "absolute",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "width": "100%",
          "text-align": "center"
        }
      }, [_vm._v("\n                            " + _vm._s(_vm.visits[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.visits[n - 1][cell + _vm.startWindow - 1]['note']['text'] : '') + "\n                          ")])]) : _vm._e()]
    })], 2)]
  })], 2) : _c('tbody', _vm._l((7), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        staticClass: "blank_windows"
      }, [_vm._v("\n                         \n                    ")])
    })], 2)
  }))]), _vm._v(" "), (_vm.visits === false || _vm.visitsPending === true) ? _c('div', {
    staticClass: "table_overlay"
  }, [(_vm.visitsPending === true) ? _c('div', {}, [_c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "h4"
  })])]) : (_vm.visits === false) ? _c('div', {
    staticClass: "text-danger"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "h4"
  }, [_vm._v("Musíte zvolit doktora")])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center"
  }, [(!_vm.putVisitPending) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "visit-reschedule-submit"
    },
    on: {
      "click": _vm.updateVisit
    }
  }, [_vm._v("Přeplánovat návštěvu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790114e9","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/modals/ChangeVisit.vue
// module id = 620
// module chunks = 0